import api from '@/utils/api';

/**
 * Create user
 * @param {object} userRoleData - The user data
 * @returns {Promise}
 */
const createUserRolePost = (userRoleData) =>
  api.post('/user-role', userRoleData);

export default createUserRolePost;
